export const gameVersions = [
  'live',
  'classic_progression',
  'classic_anniversary',
  'classic_era',
] as const

export const gameVersionToSubdomain = {
  live: '',
  classic_era: 'vanilla.',
  classic_anniversary: 'anniversary.',
  classic_progression: 'classic.',
} as const

type GameVersion = typeof gameVersions[number]

export const gameVersionToLogo: Record<GameVersion, string> = {
  live: 'midnight',
  classic_era: 'vanilla-classic',
  classic_anniversary: 'tbc-classic',
  classic_progression: 'mop-classic',
}

export const gameVersionHref = (version: GameVersion) => {
  const protocol = location.host.includes('local') ? 'http' : 'https'
  const baseHost = location.host
    .replace('live.', '')
    .replace('classic.', '')
    .replace('vanilla.', '')
    .replace('anniversary.', '')

  return `${protocol}://${gameVersionToSubdomain[version]}${baseHost}`
}

export const gameVersionLogo = (version: GameVersion) =>
  `${window.page_info.assetHost}/images/game-versions/${gameVersionToLogo[version]}-logo.avif`

export default GameVersion
